import create from "zustand";

const useViewStore = create((set) => ({
    filter: '',
    setFilter: (filter) => set(() => ({ filter })),
}))
export default useViewStore
